export default __webpack_public_path__ + "static/media/march-2019.2dd28b17.csv";